const ISAIPLAYER = "ai/ISAIPLAYER";
const ACTIVECARDINDEX = "ai/ACTIVECARDINDEX";
const PREVCARD = "ai/PREVCARD";
const NEXTCARD = "ai/NEXTCARD";
const ACTIVEENGTAB = "ai/ACTIVEENGTAB";

export const setIsAiPlayer = (payload) => ({ type: ISAIPLAYER, payload });
export const setActiveCardIndex = (payload) => ({ type: ACTIVECARDINDEX, payload });
export const nextCard = () => ({ type: NEXTCARD });
export const prevCard = () => ({ type: PREVCARD });
// AI영어>AI추천문법학습 문항 뷰어 이동 후에도 탭 유지
export const setActiveEngTab = (payload) => ({ type: ACTIVEENGTAB, payload });

const initialState = {
    isAiPlayer: false,
    activeCardIndex: 0,
    activeEngTab: { seq: 0, title: "" },
};

export default function aiReducer(state = initialState, action) {
    switch (action.type) {
        case ISAIPLAYER:
            return {
                ...state,
                isAiPlayer: action.payload,
            };
        case ACTIVECARDINDEX:
            return {
                ...state,
                activeCardIndex: action.payload,
            };
        case NEXTCARD:
            return {
                ...state,
                activeCardIndex: state.activeCardIndex + 1,
            };
        case PREVCARD:
            return {
                ...state,
                activeCardIndex: state.activeCardIndex - 1,
            };
        case ACTIVEENGTAB:
            return {
                ...state,
                activeEngTab: action.payload,
            };
        default:
            return state;
    }
}
